import { ProductType } from '@inter-ikea-storageone/range';
import { showDrillTemplateSheet } from 'rangeConfig/shared/features/HandlesDrillTemplate/HandlesDrillTemplate';
import { BehaviorParameters } from 'rangeConfig/@types';

const showHandlesDrillTemplateSheet = ({ coreApi, dispatch, rootState }: BehaviorParameters) => {
  const drillTemplateProduct = rootState.products.inMarket.find(
    p => p.type === ProductType.HANDLE_DRILL_TEMPLATE
  );
  const handlesInScene = coreApi.entities.getByProductTypes([ProductType.HANDLE, ProductType.KNOB]);
  const drillTemplateInScene = coreApi.entities.getByProductType(
    ProductType.HANDLE_DRILL_TEMPLATE
  )[0];
  if (drillTemplateProduct && handlesInScene.length > 0 && !drillTemplateInScene) {
    dispatch(showDrillTemplateSheet());
  }
};

export default showHandlesDrillTemplateSheet;
